module.exports = __webpack_public_path__ + "static/media/editVault.c7e632ea.svg";